import { isTypeVideoSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulVideoSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeVideoSection(entry)) {
    return null;
  }

  return (
    <div className='-mx-2 float-left w-full relative'>
      <h2>{entry.fields.title}</h2>
      {/* TODO: Is this always an embed? */}
      {entry.fields.videoEmbed && (
        // These nested divs are a mess, but it's copied directly from the legacy app implementation, including the custom
        // video- classes
        <div className='flex pb-8 -mr-4'>
          {' '}
          {/* negative right margin is a new adjustment needed due to React app side margins */}
          <div className='video-wrapper w-full h-full max-w-[900px] mx-auto my-0'>
            <div className='video-iframe relative pt-[56%]'>
              <div dangerouslySetInnerHTML={{ __html: entry.fields.videoEmbed }} />
            </div>
          </div>
        </div>
      )}
      {/*{
        <video width='320' height='240' controls>
          <source src={entry.fields.videoEmbed} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      }*/}
    </div>
  );
};

export default ContentfulVideoSection;
